import { defineNuxtPlugin, useHead } from '#imports';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
// 阿里云 arms 监控
export default defineNuxtPlugin(nuxtApp => {
  const ratio = 0.5;
  let armsScript = {};

  if (['production'].includes(GLOBAL_CONFIG.env)) {
    armsScript = {
      type: 'text/javascript',
      // 'head' | 'bodyClose' | 'bodyOpen'
      tagPosition: 'bodyClose',
      innerHTML: `
        (function(){
          if (Math.random() > ${ratio}) return;
          const script = document.createElement("script");
          script.setAttribute("type", "text/javascript");
          // document.body.appendChild(script);
          script.textContent='!(function(c,b,d,a){c[a]||(c[a]={});c[a].config={pid:"b5hfowf5rl@c73d2bb6695362c",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",sendResource:true,enableLinkTrace:true,behavior:true,disableHook:true};with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)})(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");';
          document.body.appendChild(script);
        })()
    `,
    };
  }

  useHead({
    script: armsScript as any,
  });
});
